import {
    EXPORT_TO_CSV_FAILURE,
    EXPORT_TO_CSV_REQUEST,
    EXPORT_TO_CSV_SUCCESS,
    EXPORT_TO_IMAGE_FAILURE,
    EXPORT_TO_IMAGE_REQUEST,
    EXPORT_TO_IMAGE_SUCCESS,
    EXPORT_TO_PDF_FAILURE,
    EXPORT_TO_PDF_REQUEST,
    EXPORT_TO_PDF_SUCCESS
} from '../actions/types/export-report-action-types';

import { combineReducers } from 'redux';

const initialIsFetchingChartImageState = {
    authenticationChart: false,
    coverageChart: false,
    domainPortfolioChart: false,
    effectivenessChart: false,
    error: '',
    messageVolumeChart: false,
};

function isFetchingChartImage( state = initialIsFetchingChartImageState, action ){
    let newState;
    switch( action.type ){
        case EXPORT_TO_IMAGE_REQUEST:
            newState = { ...state, [action.chartName]: true };
            break;
        case EXPORT_TO_IMAGE_SUCCESS:
            newState = { ...state, [action.chartName]: false };
            break;
        case EXPORT_TO_IMAGE_FAILURE:
            newState = {
                ...state,
                [action.chartName]: false,
                error: `Error fetching image on ${action.chartName}: ${action.error}`,
            };
            break;
        default:
            return state;
    }

    return newState;
}

function isFetchingPdf( state = false, action ){
    let newState;
    switch( action.type ){
        case EXPORT_TO_PDF_REQUEST:
            newState = true;
            break;
        case EXPORT_TO_PDF_SUCCESS:
        case EXPORT_TO_PDF_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

const initialIsExportingCSV = {
    authentication: false,
    coverage: false,
    effectiveness: false,
    error: '',
    messageVolume: false,
};

function isExportingCSV( state = initialIsExportingCSV, action ){
    let newState;
    const { tableName, error } = action;

    switch( action.type ){
        case EXPORT_TO_CSV_REQUEST:
            newState = { ...state, [tableName]: true };
            break;
        case EXPORT_TO_CSV_SUCCESS:
            newState = { ...state, [tableName]: false };
            break;
        case EXPORT_TO_CSV_FAILURE:
            newState = {
                ...state,
                error: `Error exporting grid to csv on ${tableName}: ${error.message}`,
                [tableName]: false,
            };
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    isExportingCSV,
    isFetchingChartImage,
    isFetchingPdf,
} );
